import React from 'react'
import './index.css'
import { useHistory } from 'react-router'
import { BackArrowIcon } from '../../conf/images'

interface HeaderProps {
    title?: string
    className?: string
    backable?: boolean
    onBack?: () => void
}
const Header: React.FC<HeaderProps> = (props) => {
    const { title, className = '', backable = true } = props
    const history = useHistory()
    return (
        <div className={`wl-header ${className}`}>
            {backable && (
                <img
                    className='wl-header-back'
                    src={BackArrowIcon}
                    alt='back'
                    onClick={(e) => {
                        e.stopPropagation()
                        if (props.onBack) {
                            props.onBack()
                        } else {
                            history.goBack()
                        }
                    }}
                />
            )}
            {title && <p className='title'>{title}</p>}
            {props.children}
        </div>
    )
}

export default Header
